/*// src/pages/ChangeLogPage.jsx
import React, { useContext, useEffect, useState } from "react";
import { ServerContext } from "../../common/context/ServerContext";

// SketchLayout.jsx
import {
  Box,
  Paper,
  Typography,
  Divider,
  Stack,
  Autocomplete,
  TextField,
} from "@mui/material";


function SectionBlock({
  titleLeft,
  dateText,
  versionText = "versão dashboard 1.0.2",
  children,
}) {
  return (
    <Box sx={{ width: "100%" }}>
      
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          px: 1,
          mb: 0.75,
        }}
      >
        <Typography variant="body2" sx={{ justifySelf: "start" }}>
          {titleLeft}
        </Typography>

        <Typography variant="body2" sx={{ justifySelf: "center" }}>
          {dateText}
        </Typography>

        <Typography
          variant="body2"
          sx={{ justifySelf: "end", whiteSpace: "nowrap" }}
        >
          {versionText}
        </Typography>
      </Box>

      
      <Paper
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "text.primary",
          borderRadius: 2, // ou 8px / 12px
          boxShadow: 1,
          p: 2,
          minHeight: 110,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}

export default function SketchDashboardMUI() {
 
  const [dataFiltro, setDataFiltro] = useState(""); // "YYYY-MM-DD"

  const semanasData = [
  {
    semanaLabel: "SE 52-2025",
    blocos: [
      {
        key: "dados-1",
        titleLeft: "Atualizações de Dados",
        dateText: "20/12/2025 00:00:00",
        versao: "versão dashboard 1.0.2",
        content: (
          <Stack spacing={0.5}>
            <Typography variant="body2">PIP - SIM</Typography>
            <Typography variant="body2">APS - NÃO</Typography>
          </Stack>
        ),
      },
      {
        key: "dados-2",
        titleLeft: "Atualizações de Dados",
        dateText: "19/12/2025 00:00:00",
        versao: "versão dashboard 1.0.2",
        content: (
          <Stack spacing={0.5}>
            <Typography variant="body2">PIP - SIM</Typography>
            <Typography variant="body2">APS - NÃO</Typography>
          </Stack>
        ),
      },
      {
        key: "dashboard",
        titleLeft: "Atualizações de Estrutura do Dashboard",
        dateText: "20/12/2025 00:00:00",
        versao: "versão dashboard 1.0.2",
        content: <Typography variant="body2">Sim - Observações</Typography>,
        minHeight: 70,
      },
      {
        key: "modelos",
        titleLeft: "Alteração de Modelos Matemáticos e Algoritmos",
        dateText: "20/12/2025 00:00:00",
        versao: "versão dashboard 1.0.2",
        content: <Typography variant="body2">Não</Typography>,
        minHeight: 70,
      },
    ],
  },
  {
    semanaLabel: "SE 01-2026",
    blocos: [
      {
        key: "dados-1",
        titleLeft: "Atualizações de Dados",
        dateText: "21/01/2025 00:00:00",
        versao: "versão dashboard 1.0.3",
        content: (
          <Stack spacing={0.5}>
            <Typography variant="body2">PIP - SIM</Typography>
            <Typography variant="body2">APS - NÃO</Typography>
          </Stack>
        ),
      },
      {
        key: "dados-2",
        titleLeft: "Atualizações de Dados",
        dateText: "25/01/2025 00:00:00",
        versao: "versão dashboard 1.0.3",
        content: (
          <Stack spacing={0.5}>
            <Typography variant="body2">PIP - SIM</Typography>
            <Typography variant="body2">APS - NÃO</Typography>
          </Stack>
        ),
      },
      {
        key: "dashboard",
        titleLeft: "Atualizações de Estrutura do Dashboard",
        dateText: "20/01/2025 00:00:00",
        versao: "versão dashboard 1.0.3",
        content: <Typography variant="body2">Sim - Observações</Typography>,
        minHeight: 70,
      },
      {
        key: "modelos",
        titleLeft: "Alteração de Modelos Matemáticos e Algoritmos",
        dateText: "21/01/2025 00:00:00",
        versao: "versão dashboard 1.0.3",
        content: <Typography variant="body2">Não</Typography>,
        minHeight: 70,
      },
    ],
  },
];

  // pega todas as semanas disponíveis (aqui usei o label do topo, mas pode vir do backend)
  const semanasDisponiveis = semanasData.map((s) => s.semanaLabel);
  const [semanasSelecionadas, setSemanasSelecionadas] = useState(semanasDisponiveis); // todas

  // converte "20/12/2025 00:00:00" -> "2025-12-20" (pra comparar com input type="date")
  const toISODate = (brDateTime) => {
    if (!brDateTime) return "";
    const [d, m, y] = brDateTime.split(" ")[0].split("/");
    return `${y}-${m}-${d}`;
  };

  // junta tudo em uma lista só e coloca semana em cada bloco
  const todosBlocos = semanasData.flatMap((s) =>
    s.blocos.map((b) => ({ ...b, semanaLabel: s.semanaLabel }))
  );

  const blocosFiltrados = todosBlocos.filter((b) => {
    const okSemana = semanasSelecionadas.includes(b.semanaLabel);
    const okData = !dataFiltro || toISODate(b.dateText) === dataFiltro;
    return okSemana && okData;
  });
  
  

const semanasOrdenadas = [...semanasSelecionadas].sort();


  return (
    <Box sx={{ p: 3, width: "75%",
    mx: "auto", }}>
      
      <Box sx={{ mb: 2 }}>
  <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
    Log das Atualizações
  </Typography>

  <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
    <Autocomplete
      multiple
      options={semanasDisponiveis}
      value={semanasSelecionadas}
      onChange={(_, v) => setSemanasSelecionadas(v)}
      renderInput={(params) => (
        <TextField  {...params}
          label="Semanas"
          size="small"
          sx={{
            "& .MuiInputBase-root": {
              alignItems: "center",
            },
          }} />
      )}
      sx={{
        minWidth: 280,
        flex: 1,
        "& .MuiInputBase-root": {
          
          minHeight: 40,          // altura padrão do size="small"
          alignItems: "stretch",   // ou "center" dependendo do layout
          alignContent: "normal",
        },
      }}
    />

  </Stack>
</Box>

      
      <Box
        sx={{
          border: "1px solid",
          borderColor: "text.primary",
          borderRadius: 2, // ou 8px / 12px
          boxShadow: 1,
          p: 2,
        }}
      >
        <Stack spacing={3}>
      {semanasOrdenadas.map((semanaLabel) => {
        const blocosDaSemana = blocosFiltrados.filter((b) => b.semanaLabel === semanaLabel);
        if (blocosDaSemana.length === 0) return null;

        return (
          <Box key={semanaLabel}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {semanaLabel}
            </Typography>

            <Box
              sx={{
                border: "1px solid",
                borderColor: "text.primary",
                borderRadius: 2,
                boxShadow: 1,
                p: 2,
              }}
            >
              <Stack spacing={2}>
                {blocosDaSemana
                  .filter((b) => b.key.startsWith("dados"))
                  .map((b) => (
                    <SectionBlock
                      key={b.key}
                      titleLeft={b.titleLeft}
                      dateText={b.dateText}
                      versionText={b.versao}
                    >
                      {b.content}
                    </SectionBlock>
                  ))}

                <Divider sx={{ borderColor: "text.primary", borderBottomWidth: 1, borderRadius: 2, boxShadow: 1 }} />

                {blocosDaSemana
                  .filter((b) => b.key === "dashboard" || b.key === "modelos")
                  .map((b) => (
                    <SectionBlock
                      key={b.key}
                      titleLeft={b.titleLeft}
                      dateText={b.dateText}
                      versionText={b.versao}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          border: "1px solid",
                          borderColor: "text.primary",
                          borderRadius: 2,
                          boxShadow: 1,
                          p: 1.25,
                          minHeight: 40,
                        }}
                      >
                        {b.content}
                      </Paper>
                    </SectionBlock>
                  ))}
              </Stack>
            </Box>
          </Box>
        );
      })}
    </Stack>
      </Box>
    </Box>
  );
}*/


// src/pages/ChangeLogPage.jsx
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ServerContext } from "../../common/context/ServerContext"; // se você usa baseUrl daqui
import {
  Box,
  Paper,
  Typography,
  Divider,
  Stack,
  Autocomplete,
  TextField,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Chip,
  MenuItem,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { TemaContext } from "../../common/context/TemaContext";


/**
 * Componente genérico de “seção”
 * - Linha de cabeçalho: título (esquerda) | data (centro) | versão (direita)
 * - Caixa grande com borda e conteúdo interno
 */
function SectionBlock({ titleLeft, dateText, versionText = "", children, theme }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          px: 1,
          mb: 0.75,
        }}
      >
        <Typography variant="body2" sx={theme === "dark" ? { color: "black", justifySelf: "center"} : {justifySelf: "center" }}>
          {titleLeft}
        </Typography>

        <Typography variant="body2" sx={theme === "dark" ? { color: "black", justifySelf: "center"} : {justifySelf: "center" }}>
          {dateText}
        </Typography>

        <Typography
          variant="body2"
          sx={theme === "dark" ? { color: "black", justifySelf: "end", whiteSpace: "nowrap" } : {justifySelf: "end", whiteSpace: "nowrap" }}
        >
          {versionText}
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "text.primary",
          borderRadius: 2,
          boxShadow: 1,
          p: 2,
          minHeight: 50,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}

// ---------- helpers ----------
function weekLabel(ano, semana) {
  const w = String(semana).padStart(2, "0");
  return `SE ${w}-${ano}`;
}

function weekKey(ano, semana) {
  // chave ordenável
  return `${ano}-${String(semana).padStart(2, "0")}`;
}

function formatCreatedAtPtBR(createdAt) {
  // "2026-02-26 16:52:13" -> "26/02/2026 16:52:13"
  if (!createdAt) return "";
  const [datePart, timePart] = String(createdAt).split(" ");
  if (!datePart) return String(createdAt);
  const [y, m, d] = datePart.split("-");
  return `${d}/${m}/${y}${timePart ? ` ${timePart}` : ""}`;
}

function renderDescricaoMultiline(text) {
  const safe = String(text ?? "");
  const lines = safe.split(/\r?\n/);
  return (
    <Stack spacing={0.5}>
      {lines.map((line, idx) => (
        <Typography key={idx} variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {line}
        </Typography>
      ))}
    </Stack>
  );
}

function renderDescricaoAsHtml(text) {
  const raw = String(text ?? "");

  // Sanitiza e permite tags seguras (incluindo <a>)
  const clean = DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel"],
  });

  return (
    <Typography
      variant="body2"
      sx={{ whiteSpace: "pre-wrap" }}
      // renderiza HTML já sanitizado
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

/**
 * Mapeia tipo_change_log para “categoria” de layout.
 * Ajuste conforme seus ids reais.
 * Exemplo:
 *  1 = dados
 *  2 = estrutura dashboard
 *  3 = modelos
 */
const tipoToCategoria = (tipo) => {
  const t = Number(tipo);
  if (t === 1) return "dados";
  // ajuste aqui se tiver outros ids
  return "outros";
};

export default function ChangeLogPage() {
  // Se você tem baseUrl no ServerContext, use. Se não, pode remover.
  const {servidor} = React.useContext(ServerContext);
  const baseUrl = servidor ?? ""; // ajuste conforme seu context

  const navigate = useNavigate();

  const {theme} = useContext(TemaContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [items, setItems] = useState([]); // lista vinda de payload.data
  const [dataFiltro, setDataFiltro] = useState(""); // (se você quiser reativar filtro por data)

  const { t, i18n } = useTranslation();

  // Buscar changelogs
  useEffect(() => {
    let alive = true;

    async function run() {
      setLoading(true);
      setError("");

      try {
        console.log("Fetching changelogs from", `${baseUrl}/api/changelogs?page=1`);
        const res = await fetch(`${baseUrl}/api/changelogs?page=1`, {
          headers: { Accept: "application/json" },
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const payload = await res.json();
        const list = Array.isArray(payload?.data) ? payload.data : [];

        if (!alive) return;
        setItems(list);
      } catch (e) {
        if (!alive) return;
        setError(
          `Não foi possível carregar os changelogs. ${
            e?.message ? `(${e.message})` : ""
          }`
        );
      } finally {
        if (alive) setLoading(false);
      }
    }

    run();
    return () => {
      alive = false;
    };
  }, [baseUrl]);

  // Agrupa por semana (ano+semana)
  const semanasMap = useMemo(() => {
    const map = new Map(); // key: "2026-08" -> { label, ano, semana, blocos: [] }

    for (const it of items) {
      const ano = it.ano;
      const semana = it.semana;
      if (ano == null || semana == null) continue;

      const k = weekKey(ano, semana);
      if (!map.has(k)) {
        map.set(k, {
          key: k,
          semanaLabel: weekLabel(ano, semana),
          ano,
          semana,
          blocos: [],
        });
      }

      map.get(k).blocos.push(it);
    }

    // ordena blocos dentro da semana por created_at desc (o backend já manda desc, mas garante)
    for (const v of map.values()) {
      v.blocos.sort((a, b) =>
        String(b.created_at || "").localeCompare(String(a.created_at || ""))
      );
    }

    return map;
  }, [items]);

  const semanasDisponiveis = useMemo(() => {
    // ordena por ano-semana desc
    return Array.from(semanasMap.values())
      .sort((a, b) => b.key.localeCompare(a.key))
      .map((s) => s.semanaLabel);
  }, [semanasMap]);

  const [semanasSelecionadas, setSemanasSelecionadas] = useState([]);

  // quando carregar as semanas pela primeira vez, seleciona todas por padrão
  useEffect(() => {
    if (semanasDisponiveis.length && semanasSelecionadas.length === 0) {
      setSemanasSelecionadas(semanasDisponiveis);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semanasDisponiveis.join("|")]);

  // filtro (semanas + opcional data)
  const semanasOrdenadas = useMemo(() => {
    // ordena desc pela chave derivada (ano-semana)
    const labelToKey = (label) => {
      // "SE 08-2026" -> "2026-08"
      const m = String(label).match(/SE\s+(\d+)-(\d{4})/);
      if (!m) return label;
      const w = String(m[1]).padStart(2, "0");
      const y = m[2];
      return `${y}-${w}`;
    };

    return [...semanasSelecionadas].sort(
      (a, b) => labelToKey(b).localeCompare(labelToKey(a))
    );
  }, [semanasSelecionadas]);

  // (opcional) converter created_at para comparar com dataFiltro "YYYY-MM-DD"
  const toISODateFromCreatedAt = (createdAt) => {
    if (!createdAt) return "";
    return String(createdAt).split(" ")[0]; // "YYYY-MM-DD"
  };

  return (
    <Box sx={{ p: 3, width: "75%", mx: "auto" }}>
      <Box sx={{ mb: 2 }}>
        {/*<Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Log das Atualizações
        </Typography>*/}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <IconButton
            onClick={() => navigate("/")}
            size="small"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              maxWidth: 32,
            }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Log das Atualizações
          </Typography>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
         
          <FormControl size="small" sx={{ minWidth: 280, flex: 1 }}>
            <InputLabel id="semanas-label">Semanas</InputLabel>

            <Select
              labelId="semanas-label"
              id="semanas-select"
              multiple
              value={semanasSelecionadas}
              onChange={(e) => setSemanasSelecionadas(e.target.value)}
              input={<OutlinedInput label="Semanas" />}
              renderValue={(selected) => (
                <Stack gap={1} direction="row" flexWrap="wrap">
                  {selected.map((value) => (
                    <Chip
                      key={value}
                      label={value}
                      sx={theme === "dark" ? { color: "white", backgroundColor: "#2f3136" } : {  }}
                      onDelete={() => {
                        // se quiser permitir "não deixar vazio", mantenha este if
                        // se quiser permitir zerar, remova o if
                        if (semanasSelecionadas.length > 1) {
                          setSemanasSelecionadas(
                            semanasSelecionadas.filter((item) => item !== value)
                          );
                        }
                      }}
                      deleteIcon={
                        <CancelIcon onMouseDown={(event) => event.stopPropagation()} />
                      }
                    />
                  ))}
                </Stack>
              )}
            >
              {semanasDisponiveis.map((name) => (
                <MenuItem
                  key={name}
                  value={name}
                  sx={{ justifyContent: "space-between" }}
                >
                  {name}
                  {semanasSelecionadas.includes(name) ? (
                    <img
                      src="/flu/imagens/check.png"
                      style={{ width: "15px", height: "15px" }}
                      alt="Selecionado"
                    />
                  ) : null}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Se quiser reativar filtro por data:
          <TextField
            type="date"
            label="Data"
            size="small"
            value={dataFiltro}
            onChange={(e) => setDataFiltro(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 180 }}
          />
          */}
        </Stack>

        {loading && (
          <Stack direction="row" spacing={1} sx={{ mt: 2, alignItems: "center" }}>
            <CircularProgress size={18} />
            <Typography variant="body2">Carregando…</Typography>
          </Stack>
        )}

        {!!error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Box>

      <Box
        sx={{
          border: "1px solid",
          borderColor: "text.primary",
          borderRadius: 2,
          boxShadow: 1,
          p: 2,
        }}
      >
        <Stack spacing={3}>
          {semanasOrdenadas.map((semanaLabel) => {
            // acha a semana correspondente
            const wk = (() => {
              const m = String(semanaLabel).match(/SE\s+(\d+)-(\d{4})/);
              if (!m) return null;
              return semanasMap.get(`${m[2]}-${String(m[1]).padStart(2, "0")}`);
            })();

            if (!wk) return null;

            // aplica filtro por data (opcional)
            const blocosDaSemana = wk.blocos.filter((it) => {
              if (!dataFiltro) return true;
              return toISODateFromCreatedAt(it.created_at) === dataFiltro;
            });

            if (blocosDaSemana.length === 0) return null;

            const blocosDados = blocosDaSemana.filter(
              (it) => tipoToCategoria(it.tipo_change_log) === "dados"
            );
            const blocosOutros = blocosDaSemana.filter(
              (it) => tipoToCategoria(it.tipo_change_log) !== "dados"
            );

            return (
              <Box key={wk.key}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {wk.semanaLabel}
                </Typography>

                <Box
                  sx={{
                    border: "1px solid",
                    borderColor: "text.primary",
                    borderRadius: 2,
                    boxShadow: 1,
                    p: 2,
                    backgroundColor: "#e7e7e7"
                  }}
                >
                  <Stack spacing={2}>
                    {blocosDados.map((it) => (
                      <SectionBlock
                        key={`cl-${it.id_change_log}`}
                        titleLeft={it.descricao_pt || it.titulo || "Atualização"}
                        dateText={formatCreatedAtPtBR(it.created_at)}
                        versionText={
                          it.versao ? `versão dashboard ${it.versao}` : ""
                        }
                        theme={theme}
                      >
                        {renderDescricaoAsHtml(it.descricao)}
                      </SectionBlock>
                    ))}

                    {blocosDados.length > 0 && blocosOutros.length > 0 && (
                      <Divider
                        sx={{
                          borderColor: "text.primary",
                          borderBottomWidth: 1,
                          borderRadius: 2,
                          boxShadow: 1,
                        }}
                      />
                    )}

                    {blocosOutros.map((it) => (
                      <SectionBlock
                        key={`cl-${it.id_change_log}`}
                        titleLeft={it.descricao_pt || it.titulo || "Atualização"}
                        dateText={formatCreatedAtPtBR(it.created_at)}
                        versionText={
                          it.versao ? `versão dashboard ${it.versao}` : ""
                        }
                        theme={theme}
                      >
                        <Paper
                          elevation={0}
                          sx={{
                            border: "1px solid",
                            borderColor: "text.primary",
                            borderRadius: 2,
                            boxShadow: 1,
                            p: 1.25,
                          }}
                        >
                          {renderDescricaoAsHtml(it.descricao)}
                        </Paper>
                      </SectionBlock>
                    ))}
                  </Stack>
                </Box>
              </Box>
            );
          })}
        </Stack>

        {!loading && !error && items.length === 0 && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            Nenhum changelog encontrado.
          </Typography>
        )}
      </Box>
    </Box>
  );
}